import React from 'react';
import ReactDom from 'react-dom';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import colors from 'styles/colors';

// Styled components for responsive design
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  maxWidth: '100%',
  overflowX: 'auto',
  borderRadius: '0',
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100vw',
  },
}));

const StyledTable = styled(Table)(({ theme }) => ({
  minWidth: 400,
  [theme.breakpoints.down('sm')]: {
    minWidth: 300,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: '7px 9px',
  fontSize: 14,
  lineHeight: '20px',
  border: `1px solid ${theme.palette.mode === 'dark' ? 'rgb(47, 47, 47)' : 'rgb(224, 224, 224)'}`,
  minWidth: 80,
  maxWidth: 240,
  minHeight: 32,
  verticalAlign: 'top',
  textAlign: 'start',
}));

const HeaderTableCell = styled(StyledTableCell)({
  fontWeight: 'bold',
  color: `${colors.text.primary} !important`,
  fontSize: '14px !important',
});

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: colors.border.border_5p,
  'th:first-child': {
    color: '#eb5757 !important',
  },
}));

// Table data
const rows = [
  {
    device: 'device=\'cpu\'',
    maxQubits: '34',
    price: 'FREE',
    description: 'Statevector Simulator based on Google’s qsim library',
  },
  {
    device: 'device=\'mps.cpu\'',
    maxQubits: '96',
    price: 'FREE up to 10min\n'
      + '$0.3/hour after',
    description: 'MPS Simulator based on Quimb library, on CPUs',
  },
  {
    device: 'device=\'quantum\'',
    maxQubits: '82',
    price: '$0.3 + $0.0009 / shot.',
    description: 'Rigetti Ankaa-3 quantum computer',
  },
  {
    device: 'device=\'gpu\'',
    maxQubits: '35',
    price: '$3/hour/gpu',
    description: 'GPU Statevector Simulator based on Nvidia cuQuantum',
  },
  {
    device: 'device=\'mps.gpu\'',
    maxQubits: '96',
    price: '$3/hour',
    description: 'MPS Simulator based on Quimb library, on GPUs',
  },
];

const DevicesTable = () => {
  const devicesTableContainer = document.getElementById('magicDevices_Table');

  const tableContent = (
    <Box sx={{ width: '100%', padding: '4px' }}>
      <StyledTableContainer component={Paper}>
        <StyledTable aria-label="devices table">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#182341' }}>
              <HeaderTableCell>SDK Device name</HeaderTableCell>
              <HeaderTableCell>Max Qubits</HeaderTableCell>
              <HeaderTableCell>Price</HeaderTableCell>
              <HeaderTableCell>Description</HeaderTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <StyledTableRow key={row.device}>
                <StyledTableCell component="th" scope="row">
                  {row.device}
                </StyledTableCell>
                <StyledTableCell>{row.maxQubits}</StyledTableCell>
                <StyledTableCell>{row.price}</StyledTableCell>
                <StyledTableCell style={{ whiteSpace: 'pre-line' }}>{row.description}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </StyledTable>
      </StyledTableContainer>
    </Box>
  );

  return (
    <div>
      {devicesTableContainer && ReactDom.createPortal(
        tableContent,
        devicesTableContainer,
      )}
    </div>
  );
};

export default DevicesTable;
